import { transformSDKFloatToRESTFloat } from '@wix/sdk-runtime/transformations/float';
import { transformSDKTimestampToRESTTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressLocaldeliverySpiV1LocalDeliveryProviderUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {};

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_restaurants_local-delivery-spi';

/** Retrieves list of account belongs to given instance */
export function listAccountIds(payload: object): RequestOptionsFactory<any> {
  function __listAccountIds({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.localdelivery.spi.v1.tpa',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.localdelivery.spi.v1.LocalDeliveryProvider.ListAccountIds',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressLocaldeliverySpiV1LocalDeliveryProviderUrl({
        protoPath: '/account-ids',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __listAccountIds;
}

/** Retrieves the delivery vendor business status */
export function businessStatus(payload: object): RequestOptionsFactory<any> {
  function __businessStatus({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.localdelivery.spi.v1.tpa',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.localdelivery.spi.v1.LocalDeliveryProvider.BusinessStatus',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressLocaldeliverySpiV1LocalDeliveryProviderUrl({
        protoPath: '/business-status',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __businessStatus;
}

/** Retrieves an estimate of the delivery */
export function estimateDelivery(payload: object): RequestOptionsFactory<any> {
  function __estimateDelivery({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [{ path: 'pickupTime' }, { path: 'dropoffTime' }],
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'pickupAddress.geocode.latitude' },
          { path: 'pickupAddress.geocode.longitude' },
          { path: 'dropoffAddress.geocode.latitude' },
          { path: 'dropoffAddress.geocode.longitude' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.localdelivery.spi.v1.tpa',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.localdelivery.spi.v1.LocalDeliveryProvider.EstimateDelivery',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressLocaldeliverySpiV1LocalDeliveryProviderUrl({
        protoPath: '/estimate-delivery',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'promisedPickupTime' },
              { path: 'promisedDropoffTime' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __estimateDelivery;
}

/** Creates a new delivery order */
export function createDelivery(payload: object): RequestOptionsFactory<any> {
  function __createDelivery({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [{ path: 'pickupTime' }, { path: 'dropoffTime' }],
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'pickupAddress.geocode.latitude' },
          { path: 'pickupAddress.geocode.longitude' },
          { path: 'dropoffAddress.geocode.latitude' },
          { path: 'dropoffAddress.geocode.longitude' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.localdelivery.spi.v1.tpa',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.localdelivery.spi.v1.LocalDeliveryProvider.CreateDelivery',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressLocaldeliverySpiV1LocalDeliveryProviderUrl({
        protoPath: '/create-delivery',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'pickupWindowStartTime' },
              { path: 'pickupWindowEndTime' },
              { path: 'dropoffWindowStartTime' },
              { path: 'dropoffWindowEndTime' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __createDelivery;
}
